import { KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors, type DragStartEvent } from '@dnd-kit/core'
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable'

/**
 * How a drag starts, for every sortable list. A finger needs a still long press, so a swipe stays a
 * scroll; a mouse needs a few pixels of movement. MouseSensor rather than PointerSensor: on touch
 * screens a finger also fires pointer events, and a pointer sensor would grab the card at the
 * first few pixels of a scroll, only for the browser to cancel it as the page started scrolling.
 */
export function useDragSensors(pressMs = 250) {
  return useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 6 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: pressMs, tolerance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  )
}

/**
 * A short buzz says a finger has picked the card up, where the phone supports it. Called from
 * `onDragStart`, after the long press: dnd-kit's own `onActivation` fires on the first touch, so
 * every scroll that began on a card buzzed.
 */
export function buzzOnPickUp(e: DragStartEvent) {
  if (e.activatorEvent && 'touches' in e.activatorEvent) navigator.vibrate?.(10)
}
